import {useMemo} from 'react';
import {useSelector} from 'react-redux';

function compareNewestFirst(a, b) {
    if (a.date_published === b.date_published) {
        return 0;
    }
    return a.date_published > b.date_published ? -1 : 1;
}

export function useEventNews(eventId) {
    const listed = useSelector(state => state.events[eventId]?.news?.listed);

    return useMemo(() => [...(listed ?? [])].sort(compareNewestFirst), [listed]);
}
